module.exports = __webpack_public_path__ + "static/media/fccMobile.c5c10d1c.png";